export * from './prediction-tabs';
